
/**
 * Module dependencies.
 */

import { Component } from 'react';
import { Route, Redirect as RouterRedirect } from 'react-router-dom';

/**
 * `Props` type.
 *
 * These are all props from react-router's Redirect plus `status`.
 */

type Props = {
  from?: string;
  push?: boolean;
  status: number;
  to: string | object;
};

/**
 * Export `Redirect` component.
 */

export class Redirect extends Component<Props> {

  /**
   * Render redirect.
   */

  renderRedirect = ({ staticContext }: any): JSX.Element => {
    const { status, ...rest } = this.props;

    // The `staticContext` object only exists on the server and in this case
    // is used to store the HTTP status code that should be set in the response.
    if (staticContext) {
      staticContext.status = status;
    }

    return <RouterRedirect {...rest} />;
  };

  /**
   * Render.
   */

  render(): JSX.Element {
    return <Route render={this.renderRedirect} />;
  }

}
